import React from "react";
import styles from "./ManageColors.module.css";
import Header from "../../components/header/Header";
import PageHeading from "../../components/PageHeading/PageHeading";
import {
  useGetFancyColorsListQuery,
  useUpdateFancyColorMutation,
} from "../../store/api/settingsApi";
import { useToast } from "../../hooks/useToast";

const ManageColors: React.FC = () => {
  const { data: colorsData, isLoading } = useGetFancyColorsListQuery(1);
  const [updateColor] = useUpdateFancyColorMutation();
  const { showToast } = useToast();

  const handleColorChange = async (id: number, colorCode: string) => {
    try {
      await updateColor({
        fancyColorId: id,
        colorCode,
      }).unwrap();
      showToast("Color updated successfully", "success");
    } catch (error) {
      showToast("Failed to update color", "error");
    }
  };

  return (
    <div className={styles.container}>
      <Header />
      <div className={styles.mainContent}>
        <PageHeading title="Manage Colors" />

        <div className={styles.colorsGrid}>
          {isLoading ? (
            <div>Loading...</div>
          ) : (
            colorsData?.data.map((color) => (
              <div key={color.id} className={styles.colorCard}>
                <input
                  type="color"
                  className={styles.colorPicker}
                  value={color.color_code}
                  onChange={(e) => handleColorChange(color.id, e.target.value)}
                  style={{ background: color.color_code }}
                />
                <span className={styles.colorName}>{color.name}</span>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default ManageColors;
